import React, { useState, useEffect } from "react";

import {
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  Popover,
} from "@material-ui/core";

import { Theme, makeStyles, createStyles } from "@material-ui/core/styles";

import CustomerGroupExport from "./CustomerGroupExport";
import CustomerGroupExportSkeleton from "./CustomerGroupExportSkeleton";
import AddCustomerGroupExport from "./AddCustomerGroupExport";
import { CustomerGroupListItem } from "../../../../lib/models/CustomerGroupListItem";

interface Props {
  anchorEl: null | Element | ((element: Element) => Element);
  customerGroup: CustomerGroupListItem;
  handleCloseCustomerGroupExports: () => void;
  open: boolean;
}

export default function CustomerGroupExportList({
  anchorEl,
  customerGroup,
  handleCloseCustomerGroupExports,
  open,
}: Props) {
  const classes = useStyles();
  const [showSkeleton, setShowSkeleton] = useState(false);
  useEffect(() => setShowSkeleton(false), [customerGroup]);

  const hasExports = customerGroup.groupExports?.length > 0;

  return (
    <>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleCloseCustomerGroupExports}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        disableScrollLock
      >
        {
          <List
            dense
            subheader={
              <ListSubheader component="div" id="nested-list-subheader">
                Gespeicherte Kundengruppen-Exporte
              </ListSubheader>
            }
          >
            {!hasExports && (
              <ListItem className={classes.exportListItem} button disableRipple>
                <ListItemText
                  primary={
                    "Es sind keine Exporte zu dieser Kundengruppe gespeichert."
                  }
                  className={classes.exportListItemText}
                />
              </ListItem>
            )}

            {showSkeleton && <CustomerGroupExportSkeleton />}

            {hasExports &&
              customerGroup.groupExports.map((item) => (
                <CustomerGroupExport
                  key={item.uuid}
                  customerGroup={customerGroup}
                  customerGroupExport={item}
                />
              ))}

            <AddCustomerGroupExport
              customerGroup={customerGroup}
              onSave={() => setShowSkeleton(true)}
            />
          </List>
        }
      </Popover>
    </>
  );
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    exportListItem: {
      justifyContent: "space-between",
      cursor: "auto",
      userSelect: "auto",
    },
    exportListItemText: {
      minWidth: 280,
      marginRight: 16,
    },
  })
);



// WEBPACK FOOTER //
// ./src/components/CustomerGroups/CustomerGroup/CustomerGroupExport/CustomerGroupExportList.tsx